// Mock data for Classic Interior Renovations LTD
// NOTE: This is placeholder / mock data used for the frontend-only build.

export const COMPANY = {
  name: "Classic Interior Renovations",
  legal: "Classic Interior Renovations LTD",
  tagline: "YOUR LUXURY DREAM HOME DEVELOPMENT PLANNER",
  phone: "(780) 655-7604",
  phoneHref: "tel:+17806557604",
  email: "classicinteriorrenovation@gmail.com",
  contacts: [
    { name: "Slava", phone: "(780) 655-7604", href: "tel:+17806557604" },
    { name: "Andrew", phone: "(780) 699-6902", href: "tel:+17806996902" },
  ],
  city: "Edmonton, Alberta",
  address: "Serving Edmonton & surrounding areas",
  reviewsUrl: "https://g.page/r/Cal0S5rILD5EEBM/review",
  mapUrl: "https://maps.google.com/?q=Edmonton+Alberta",
  hours: "Mon – Sat: 8:00 AM – 6:00 PM",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4MzcyMzA0OXww&ixlib=rb-4.1.0&q=85",
  kitchen1: "https://images.unsplash.com/photo-1617228069096-4638a7ffc906?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4MzcyMzA0OXww&ixlib=rb-4.1.0&q=85",
  kitchen2: "https://images.unsplash.com/photo-1556911220-bff31c812dba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4MzcyMzA0OXww&ixlib=rb-4.1.0&q=85",
  kitchen3: "https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4MzcyMzA0OXww&ixlib=rb-4.1.0&q=85",
  kitchen4: "https://images.pexels.com/photos/7166645/pexels-photo-7166645.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bath1: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3ODM3MjMwNDh8MA&ixlib=rb-4.1.0&q=85",
  bath2: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3ODM3MjMwNDh8MA&ixlib=rb-4.1.0&q=85",
  bath3: "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3ODM3MjMwNDh8MA&ixlib=rb-4.1.0&q=85",
  bath4: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3ODM3MjMwNDh8MA&ixlib=rb-4.1.0&q=85",
  living1: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4MzcyMzA1NXww&ixlib=rb-4.1.0&q=85",
  living2: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4MzcyMzA1NXww&ixlib=rb-4.1.0&q=85",
  basement1: "https://images.pexels.com/photos/29012619/pexels-photo-29012619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const STATS = [
  { value: "150+", label: "Projects Completed" },
  { value: "8+", label: "Service Areas" },
  { value: "100%", label: "Licensed & Insured" },
  { value: "10+ YRS", label: "Craftsmanship" },
];

export const SERVICES = [
  {
    slug: "kitchen",
    title: "Kitchen Renovations",
    short: "From a simple refresh to a complete transformation, there is no space more impactful to renovate than the kitchen. Our kitchen renovations make cooking and hosting more enjoyable with modern layouts, custom cabinetry and finishes that bring your style to life in the heart of your home \u2014 built to last for years of everyday use.",
    image: IMAGES.kitchen1,
    points: ["Tile-work", "Cabinetry", "Countertops", "Lighting", "Flooring", "Trim"],
    category: "residential",
  },
  {
    slug: "bathroom",
    title: "Bathroom Renovations",
    short: "Although the bathroom is often a smaller space, upgrading it can have a big impact on how your home feels day to day. We create functional, spa-like bathrooms with quality tile-work, custom vanities and thoughtful lighting \u2014 a beautiful, practical space built around the way you live and a great feature when it comes time to sell.",
    image: IMAGES.bath1,
    points: ["Tile-work", "Cabinetry", "Countertops", "Lighting", "Flooring", "Trim"],
    category: "residential",
  },
  {
    slug: "basement",
    title: "Basement Development",
    short: "Basement developments create more room for life and add considerable value to your home \u2014 as a finished space for your family or as a legal suite for future tenants. We make the most of this under-utilized area by optimizing the layout, adding egress and building everything to code, made to last.",
    image: IMAGES.basement1,
    points: ["Framing", "Bearing wall restructuring", "Stone work", "Tile work", "Outside doors"],
    category: "residential",
  },
  {
    slug: "custom",
    title: "Custom Interiors",
    short: "Sometimes your vision calls for something truly one-of-a-kind. Our custom interior work covers bespoke millwork, built-in furniture, feature walls and detailed finishing carpentry \u2014 tailored precisely to your space, your taste and the way you want to live in your home.",
    image: IMAGES.living1,
    points: ["Molding", "Furniture", "Custom millwork", "Lighting", "Flooring"],
    category: "residential",
  },
  {
    slug: "full-home",
    title: "Full Home Remodeling",
    short: "A multi-space renovation can turn an older home that doesn\u2019t quite fit right into a space made just for you and the life you want. Our full-home remodels can include everything from major structural changes to minor design updates \u2014 the home of your dreams, without the move.",
    image: IMAGES.living2,
    points: ["Framing", "Bearing wall restructuring", "Outside doors", "Stone work", "Tile work"],
    category: "residential",
  },
  {
    slug: "legal-suites",
    title: "Legal Suites",
    short: "A legal basement or secondary suite is one of the smartest ways to add income and long-term value to your Edmonton home. We handle the entire process \u2014 separate entrance, egress windows, sound and fire separation, kitchen and bathroom \u2014 all built to code and permit-ready so you can rent with confidence.",
    image: IMAGES.bath4,
    points: ["Separate entrance", "Egress windows", "Fire & sound separation", "Kitchenette", "Bathroom", "Permits & code"],
    category: "residential",
  },
  {
    slug: "design-studio",
    title: "Design Studio",
    short: "Not sure where to start? Our in-house design studio helps you plan layouts, choose finishes and visualize your renovation before a single wall is touched. We turn ideas and inspiration into a clear, buildable plan tailored to your space, your style and your budget.",
    image: IMAGES.kitchen4,
    points: ["Layout planning", "Material selection", "3D concepts", "Finish schedules", "Budget planning", "Project scoping"],
    category: "residential",
  },
  {
    slug: "commercial",
    title: "Commercial Construction",
    short: "We help Edmonton businesses create spaces that work as hard as they do. From office design and custom millwork to full commercial fit-outs, we deliver professional results on schedule and to code \u2014 with clear communication from the first quote to final walkthrough.",
    image: IMAGES.kitchen3,
    points: ["Office design", "Custom millwork", "Lighting", "Flooring"],
    category: "commercial",
  },
];

export const PROCESS = [
  { step: "01", title: "Consultation", text: "We sit down to understand your goals, space and budget before anything begins." },
  { step: "02", title: "Design & Quote", text: "Clear, itemized pricing and a design plan so you know exactly what to expect." },
  { step: "03", title: "Build", text: "A dedicated team executes with quality craftsmanship and constant communication." },
  { step: "04", title: "Final Walkthrough", text: "We review every detail together to make sure it feels built to last." },
];

export const PROJECTS = [
  { title: "Modern Elegance Kitchen", area: "Windermere", budget: "$60,000\u2013$70,000", length: "10 Weeks", image: IMAGES.kitchen1, tag: "Kitchen" },
  { title: "Spa-Inspired Bathroom", area: "Glenora", budget: "$28,000\u2013$34,000", length: "6 Weeks", image: IMAGES.bath1, tag: "Bathroom" },
  { title: "Walkout Basement Suite", area: "Terwillegar", budget: "$85,000\u2013$95,000", length: "12 Weeks", image: IMAGES.basement1, tag: "Basement" },
  { title: "Full Home Remodel", area: "Riverbend", budget: "$180,000\u2013$210,000", length: "16 Weeks", image: IMAGES.living1, tag: "Full Home" },
  { title: "Bright Family Kitchen", area: "Summerside", budget: "$45,000\u2013$52,000", length: "8 Weeks", image: IMAGES.kitchen2, tag: "Kitchen" },
  { title: "Contemporary Ensuite", area: "Hollick Kenyon", budget: "$32,000\u2013$38,000", length: "7 Weeks", image: IMAGES.bath2, tag: "Bathroom" },
];

export const TESTIMONIALS = [
  { name: "Megan Trufyn", role: "Basement Suite", rating: 5, text: "Right from getting a quote you could tell they knew what they were doing. Professional, detailed and everything done to code. They stayed within our budget and made the whole process so easy." },
  { name: "Tom H.", role: "Kitchen Remodel", rating: 5, text: "Down to earth and easy to deal with. The craftsmanship was excellent and the team respected our home every single day. Highly recommended!" },
  { name: "Lindsey Veenstra", role: "Full Renovation", rating: 5, text: "We were impressed with their professionalism, quality of work and how nice they were to work with. We are so happy with the finished result. Highly recommend." },
  { name: "Andrew P.", role: "Bathroom Renovation", rating: 5, text: "Clear communication from start to finish. The finished bathroom exceeded our expectations and was completed on schedule." },
];

export const OWNERS = {
  names: "Andrew & Slava",
  text: "We are the owners of Classic Interior Renovations. Our promise is simple: if we wouldn't accept it for our own home, we won't accept it for yours. Every project is backed by creativity, craftsmanship and attention to detail \u2014 with transparency at every step.",
  image: "/owners-classic.jpg",
};

export const NAV = [
  { label: "About", to: "/about" },
  { label: "Residential", to: "/services#residential" },
  { label: "Commercial", to: "/commercial" },
  { label: "Projects", to: "/projects" },
  { label: "Contact", to: "/contact" },
];
